<template lang="pug">
.app
  .names(v-if="picknames == true")
    pre-game-screen
  .game(v-if="picknames == false")
    .brackets
      button(type="button" @click="showModal" class="button" v-if="buttonswitch == false" :disabled="dis") Submit score!
      button(type="button" @click="resetWinnerBracket" class="button" v-if="buttonswitch == true") Reset board
      button(type="button" @click="backToPregame" class="button") Change names
      Modal(v-if="show" :turn="turns[index]" :game="nextGame")
      h2 Winners Bracket
      bracket-component(:names="players")
      h2 Losers Bracket
      loser-bracket-component
    .score
      end-game-component(:players="players")
</template>

<script>
import BracketComponent from '@/components/BracketComponent.vue'
import LoserBracketComponent from '@/components/LoserBracketComponent.vue'
import EndGameComponent from '@/components/EndGameComponent.vue'
import PreGameScreen from '@/components/PreGameScreen.vue'
import Modal from '@/components/ModalComponent.vue'
import Event from '../event.js';
export default {
  name: 'home',
  components: {
    BracketComponent,
    LoserBracketComponent,
    Modal,
    EndGameComponent,
    PreGameScreen
  },
  data () {
    return {
      show: false,
      turns: ['w', 'w', 'w', 'w', 'l', 'l', 'w', 'w', 'l', 'l', 'w', 'l', 'l', 'w', 'w'],
      index: 0,
      wgame: undefined,
      lgame: undefined,
      players: undefined,
      names: undefined,
      buttonswitch: false,
      picknames: true,
      dis: false,
    }
  },
  methods: {
    resetWinnerBracket(){
      Event.$emit('reset');
      this.buttonswitch = !this.buttonswitch;
      this.index = 0;
    },
    showModal() {
      this.dis = true;
      if(this.nextGame.players[0] == undefined) {
        Event.$emit('submitScore', 0, 3, this.turns[this.index]);
        this.index += 1;
      } else if(this.nextGame.players[1] == undefined) {
        Event.$emit('submitScore', 3, 0, this.turns[this.index]);
        this.index += 1;
      } else {
        this.show = true;
      }
      this.dis = false;
    },
    backToPregame() {
      this.picknames = true;
    }
  },
  computed: {
    nextGame() {
      if(this.turns[this.index] == 'w') {
        return this.wgame;
      } else {
        return this.lgame;
      }
    }
  },
  beforeMount() {
    Event.$on('start tournament', players => {
      this.players = players;
      this.picknames = false;
    });
    Event.$on('closeAndSub', () => {
      this.index++;
      this.show = false;
    });
    Event.$on('close', () => {
      this.show = false;
    });
    Event.$on('Next winnergame', (game) => {
      console.log('event w');
      this.wgame = game;
    });
    Event.$on('Next losergame', (game) => {
      console.log('event l');
      this.lgame = game;
    });
    Event.$on('scores', (scores) => {
      //console.log(this.players.filter(lambda => lambda.name == scores[0]));
      this.players.filter(lambda => lambda.name == scores[0].name)[0].score += 3;
      this.players.filter(lambda => lambda.name == scores[1].name)[0].score += 2;
      this.players.filter(lambda => lambda.name == scores[2].name)[0].score += 1;
      this.players.sort((a, b) => (a.score > b.score) ? -1 : 1);
      this.buttonswitch = true;
      console.log(this.players);
    });
    /* this.players = [{name : 'Mario', score: 0}, {name : 'Michiel', score: 0}, {name : 'Luca', score: 0}, {name : 'Dave', score: 0}, {name : 'Pietj', score: 0}, {name : 'Joeri', score: 0}, {name : 'Stan', score: 0}, {name : 'Bregt', score: 0}];
    this.names = this.players.map(lambda => lambda.name); */
  }
}
</script>
<style lang="scss" scoped>
body, html{
    height: 100%;
  }

  /* #trophy {
    width: 25%;
    float: right;
    margin-top: 5%;
  } */

  .game{
    display: flex;
    flex-direction: row;
    height: 80%;
    width: 100%;
    margin-left: 0%;
    margin-bottom: 3%;
    margin-top: 1%;
  }

  .button {
    background-color: #9F1002;
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    border: 2px solid #9F1002;
    margin: 1%;
    font-size: 20px;
    font-family: Tarrget Laser;
  }
  .button:hover {
    background-color: white;
    color: black;
  }

  .brackets{
    min-width: 75%;
  }

  h2 {
    color: #a50000;
    margin-bottom: 3%;
    margin-left: 1%;
    //margin-left: 1%;
    font-size: 60px;
    font-family: Tarrget Platinum;
  }

  .laser {
    font-size: 60px;
    font-family: Tarrget Laser;
    color: red;
  }

  button {
    float: right;
    padding: 20px;
    //margin-right: 20%;
  }

</style>

